import React, { useState } from 'react'
import { formValueSelector, reduxForm } from 'redux-form'
import { Tooltip } from '@material-ui/core'
import { connect } from 'react-redux'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { simularCupos, showDetalleCuposADescargar, resetShowDestalleFechaProyeccion } from '../../actions/listados'
import InputTable from './InputTable'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import { COLORES } from '../../../../config/colores'
import { toast } from 'react-toastify'

function EstimacionCuposAsignados (props) {
  const {
    cupos,
    proyectados,
    cereal,
    fecha,
    cumplimiento,
    descargaPotencial,
    change: formChange,
    simularCupos,
    simulacion,
    currentCuposProyectados,
    simulacionesPersistidas,
    isSimulacionExportador
  } = props
  const [active, setActive] = useState(false)

  const fieldName = `cuposProyectados_${cereal}_${fecha}`

  const handleDisplay = () => {
    formChange(fieldName, currentCuposProyectados)
  }

  const handleBlur = () => {
    const currentValue = currentCuposProyectados
    const parsedValue = parseInt(currentValue)

    const proyecciones = simulacionesPersistidas && simulacionesPersistidas.filter(s => s.exportador === 'POOL' && s.fecha === fecha && s.cereal === cereal)
    const cantidad = (proyecciones[0] && proyecciones[0].cuposSimulados) || 0
    const proyeccionExportadores = simulacionesPersistidas && simulacionesPersistidas.filter(s => s.exportador !== 'POOL' && s.fecha === fecha && s.cereal === cereal)
    let cantProyeccionExp = 0

    proyeccionExportadores && proyeccionExportadores.map((p) => {
      return (cantProyeccionExp += p.cuposSimulados)
    })

    const proyeccionPoolDisponible = cantidad - cantProyeccionExp + proyectados

    if (!currentValue || isNaN(parsedValue) || parsedValue === 0) {
      formChange(fieldName, '')
      simularCupos(fecha, cereal, 0, cumplimiento)
      setActive(false)
    } else if (proyectados !== currentValue) {
      if (!isSimulacionExportador || (currentValue <= proyeccionPoolDisponible)) {
        simularCupos(fecha, cereal, parsedValue, cumplimiento)
        setActive(true)
        formChange(fieldName, '')
      } else {
        toast.error('No se puede superar la cantidad de cupos simulados en pool')
        formChange(fieldName, '')
      }
    }
    setTimeout(() => {
      setActive(false)
    }, [1500])
  }

  const showDetalleCupos = () => {
    props.resetShowDestalleFechaProyeccion()
    props.showDetalleCuposADescargar(cupos, proyectados, fecha, cumplimiento, descargaPotencial)
  }

  const parsedCupos = cupos || parseInt(cupos) || 0

  const rawProyectadosValue = (currentCuposProyectados === undefined || currentCuposProyectados === null || currentCuposProyectados === '')
    ? proyectados
    : currentCuposProyectados

  const parsedProyectados = parseInt(rawProyectadosValue) || 0
  const total = parsedCupos + parsedProyectados

  const displayValue = parsedProyectados > 0
    ? `+ ${parsedProyectados}`
    : 'Simular'

  const simulados = parsedProyectados ? `+ ${parsedProyectados} cupos proyectados` : ''
  const aDescargar = parsedCupos ? `${parsedCupos} cupos asignados ` : ''
  const detalleCuposADescargar = `${aDescargar} ${simulados}`

  return (
    <div style={{ display: 'flex', alignItems: 'center', minWidth: '100%', justifyContent: 'flex-end' }}>
      { simulacion && cupos !== 'CONFIG' &&
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            { (total) > 0 && <>
              <Tooltip title={detalleCuposADescargar} >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <span style={{ fontWeight: 'bold', color: COLORES.grey.dark }}>{total}</span>
                </div>

              </Tooltip>
              <LocalShippingIcon style={{ color: COLORES.grey.dark, marginLeft: '5px' }} />
            </> }
          </div>

          { cereal !== 'TODOS'
            ? <div
              style={{
                borderRadius: '8px',
                backgroundColor: '#ffffff24',
                margin: '0 0 0 8px',
                width: '50%'
              }}
              className={active ? 'animate-active ' : ''}
            >
              <Tooltip title={''}>
                <div>
                  <InputTable
                    style={{ padding: 0 }}
                    name={fieldName}
                    icono={null}
                    value={displayValue === 'Simular' ? '0' : displayValue}
                    handleDisplay={handleDisplay}
                    handleBlur={handleBlur}
                    colorValue={displayValue === 'Simular' ? COLORES.grey.dark : '#858585'}
                  />
                </div>
              </Tooltip>
            </div>
            : <div style={{ color: '#858585', padding: '0 12px', width: '50%' }}> {parsedProyectados > 0 && ` + ${parsedProyectados}` }</div>
          }
        </>
      }

      { !simulacion && total > 0 &&
        <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={showDetalleCupos}>
          <Tooltip title={detalleCuposADescargar}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <span style={{ fontWeight: 'bold' }}>{total}</span>
            </div>

          </Tooltip>
          <LocalShippingIcon style={{ color: COLORES.grey.dark, marginLeft: '5px' }} />
        </div>
      }

    </div>
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state, props) => {
  const fieldName = `cuposProyectados_${props.cereal}_${props.fecha}`
  return {
    cuposProyectados: selector(state, 'cuposProyectados'),
    currentCuposProyectados: selector(state, fieldName),
    simulacion: state.stock.simulacionActiva,
    simulacionesPersistidas: state.stock.simulacionesPersistidas,
    isSimulacionExportador: state.stock.isSimulacionExportador,
    espacioElevador: selector(state, 'espacioDisponibleElevador')
  }
}

const mapActionsToProps = {
  simularCupos,
  showDetalleCuposADescargar,
  resetShowDestalleFechaProyeccion
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(EstimacionCuposAsignados))
